import React, { lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import ErrorPage from './components/ErrorPage';
import LoadingView from './components/LoadingView';

const GigaVideo = lazy(() =>
  import(/* webpackChunkName: "GigaVideo" */ './components/GigaVideo'),
);

const MySpinView = lazy(() =>
  import(/* webpackChunkName: "MySpinView" */ './components/MySpinView'),
);

export default () => (
  <Suspense fallback={<LoadingView />}>
    <Switch>
      <Route path="/giga-vending-machine/:gigaId" render={({match}) => <GigaVideo match={match} />} />
      {/* (ie /myspin/xyz123) */}
      <Route exact path="/myspin/:inputId" render={({match}) => <MySpinView match={match} />} />
      <Route exact path="/myspin/:deprecated/upload/:inputId" render={({match}) => <MySpinView match={match} />} />
      <Route exact path="/myspin/share/:inputId" render={({match}) => <MySpinView match={match} />} />
      <Route path="/myspin/" render={() => <ErrorPage />} />
    </Switch>
  </Suspense>
);
